import { Group } from '@schooly/api';
import { AssessmentGroup } from '@schooly/api';
import React from 'react';

import RoundCard, { RoundCardProps } from '../../../../components/uikit-components/RoundCard';

interface AssessmentsGroupCardProps extends Omit<RoundCardProps<any>, 'item'> {
  group: Group | AssessmentGroup;
  isSelected?: boolean;
  onClick?: VoidFunction;
  generateHref?: (id?: string) => string;
}

const AssessmentsCreateModalGroupsItem: React.FC<AssessmentsGroupCardProps> = ({
  group,
  isSelected,
  onClick,
  generateHref,
  ...props
}) => {
  const { subject, student_count } = group || {};

  return (
    <RoundCard
      onClick={onClick}
      item={group}
      label={subject?.name}
      count={student_count}
      withTooltip
      name={group?.name}
      isSelected={isSelected}
      generateHref={generateHref}
      {...props}
    />
  );
};

export default AssessmentsCreateModalGroupsItem;
